<template>
  <div>
    <div
      class="sticky top-0 z-20"
      v-if="showSubscriptionBanner"
    >
      <transition
        enter-active-class="ease-out duration-300"
        enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        enter-to-class="opacity-100 translate-y-0 sm:scale-100"
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100 translate-y-0 sm:scale-100"
        leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      >
        <div
          class="bg-green-300 border-2 border-green-600 border-opacity-25 text-green-600 absolute text-center
                                    py-5 -mt-8 w-6/12 left-3/12 right-3/12 text-base flex items-center justify-center"
        >
          <div class="flex items-center justify-center">
            <icon
              class="inline-block mr-2"
              name="checkmark-circle-2"
            />

            <div>Votre abonnement a été validé</div>
          </div>
        </div>
      </transition>
    </div>
    <div
      class="hidden relative lg:flex items-center bg-indigo-200 overflow-visible rounded-sm h-48 w-full"
    >
      <div class="px-12 w-full">
        <p class="text-4xl text-gray-900">
          Paramètres du compte
        </p>
        <p class="mt-2 text-base font-light leading-4 2xl:leading-5 text-gray-600 xl:pr-72">
          Gérez vos informations générales, votre abonnement et retrouvez l’historique de vos paiements depuis cet espace.
        </p>
      </div>
      <illustration
        name="Group189"
        class="hidden xl:block absolute right-5 xl:right-10 w-60 xl:w-72"
      />
    </div>

    <!-- Contenu -->
    <div class="flex flex-col mt-16 mb-8">
      <div class="-my-2 py-2">
        <MessageHeader
          :message-header="messageHeader"
          v-if="tab_display == 'informations'"
        />

        <div
          v-if="isInformationsPage"
          class="sticky z-10 top-48 md:top-0 bg-black"
        >
          <!-- Save button -->
          <div
            v-if="saving"
            class="absolute flex items-center justify-center
            cursor-pointer bg-pink-600 shadow-pink
            hover:shadow-outline-pink text-white z-0 w-14 h-14
            rounded-full md:right-15 md:mt-10 ml-5/12 md:ml-0 top-96 md:top-0"
          >
            <span class="h-6 w-6 spinner spinner-save" />
          </div>
          <div
            v-else
            class="absolute flex items-center justify-center
            cursor-pointer bg-pink-600 shadow-pink
            hover:shadow-outline-pink text-white z-0 w-14 h-14
            rounded-full md:right-15 md:mt-10 ml-5/12 md:ml-0 top-96 md:top-0"
            @click="save_infos"
          >
            <icon
              name="save"
              class="h-6 w-6"
            />
          </div>
          <!-- End Save button -->
        </div>

        <div
          class="relative align-middle min-w-full shadow sm:rounded-lg border-b border-gray-200 bg-white pb-10 table min-h-halfscreen"
        >
          <h3 class="mt-5 mb-5 lg:my-15 2xl:my-20 w-full">
            Paramètres du compte
          </h3>

          <!-- TODO: Move this to a component -->
          <div class="flex justify-center items-center">
            <nav class="flex justify-between md:justify-center md:space-x-10 text-gray-600 cursor-pointer text-center overflow-x-auto w-2/3 md:w-full">
              <router-link
                :to="{name:'Accountinformations'}"
                class="flex-shrink-0 text-2xl inline-block hover:text-pink-600 font-light"
                :class="{'text-indigo-600 font-normal': tab_display == 'informations'}"
              >
                Mes informations
              </router-link>
              <router-link
                v-if="isAdminPay || $trial()"
                :to="{name:'Accountsubscription'}"
                class="flex-shrink-0 text-2xl inline-block hover:text-pink-600 font-light pl-4 md:pl-0"
                :class="{'text-indigo-600 font-normal': tab_display == 'abonnements'}"
              >
                Mon abonnement
              </router-link>
              <router-link
                v-if="isAdminPay"
                :to="{name:'Accountbillinghistory'}"
                class="flex-shrink-0 text-2xl inline-block hover:text-pink-600 font-light pl-4 md:pl-0"
                :class="{'text-indigo-600 font-normal': tab_display == 'paiements'}"
              >
                Mes historiques de paiement
              </router-link>
            </nav>

            <icon
              class="ml-3 text-indigo-600 md:hidden block"
              name="arrow-right_1"
            />
          </div>

          <router-view />
        </div>
      </div>
    </div>
    <!-- Fin Contenu -->
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import Illustration from './../../components/Illustration';
import Icon from './../../components/Icon';

import MessageHeader from './../../components/MessageHeader';

export default {
  name: 'Account',

  components:{
    Illustration,
    Icon,
    MessageHeader,
  },

  data(){
    return{
      showSubscriptionBanner: false
    };
  },

  mounted(){
    if(this.$route.query.subscriptionSuccess) {
      this.showSubscriptionBanner = true;
      setTimeout(() => this.showSubscriptionBanner = false, 8000);
    }
  },

  methods:{
    ...mapMutations({
      SET_TABDISPLAY: 'account/SET_TABDISPLAY',
      SET_ISADMINPAY: 'account/SET_ISADMINPAY',
      SET_INCOMPANY: 'account/SET_INCOMPANY',
      SET_MESSAGEHEADER: 'account/SET_MESSAGEHEADER',
      SET_SAVING: 'account/SET_SAVING',
    }),
    ...mapActions({
      save_infos: 'account/save_infos',
    }),
  },
  computed:{
    ...mapGetters({
      tab_display: 'account/tabDisplay',
      isAdminPay: 'account/isAdminPay',
      inCompany: 'account/inCompany',
      saving: 'account/saving',
      messageHeader: 'account/messageHeader',
    }),

    isInformationsPage(){
      return this.$route.name === 'Accountinformations';
    }
  }
};
</script>
